<template>
    <div v-if="webShareApiSupported" @click.prevent="share" class="share-button mx-1 pointer w-8 h-8">
        <svg-vue class="dark:text-white" :icon="'share'"></svg-vue>
    </div>
</template>

<script>
export default {
    data() {
        return {
            currentUrl: window.location.origin,
        };
    },
    computed: {
        webShareApiSupported() {
            return !!navigator.share;
        },
    },
    methods: {
        async share() {
            try {
                await navigator.share({
                    title: this.$attrs.title || 'Share this content',
                    url: this.$attrs.url || this.currentUrl,
                });
            } catch (err) {
                console.log(err);
            }
        },
    },
};
</script>
